import React from 'react';

import _ from 'lodash';

import Button from 'components/Button';
import ErrorMessage from 'components/ErrorMessage';
import Input from 'components/Input';
import TitleInput from 'components/TitleInput';
import { ENUM_PASSWORD_CREATE_ERROR } from 'constants/enum';
import { MESSAGE_COMMON, MESSAGE_REGISTER } from 'constants/string/messages';
import { TEXT_COMMON, TEXT_REGISTER } from 'constants/string/texts';
import { getJapaneseGovernments } from 'utils/helper';

const EnterAccountInfomation = ({ form, emailInValidJapan }) => {
  const japanese_government = getJapaneseGovernments() || [];

  return (
    <div className="w-indicators mx-auto">
      <fieldset data-testid="email">
        <TitleInput className="!mt-0" text={TEXT_REGISTER.EMAIL_ADDRESS} required={true} />
        <Input id="email" type="text" name="email" value={form.values.email} onChange={form.handleChange} invalid={form.errors?.email} />
        <p className={`text-sm ${form.errors.email || emailInValidJapan ? 'text-danger-229' : 'text-secondary-354'}`}>
          {!form.values.email && form.errors.email && <ErrorMessage>{MESSAGE_COMMON.NOT_EMPTY}</ErrorMessage>}
          {form.values.email ? (
            emailInValidJapan ? (
              <ErrorMessage>{MESSAGE_REGISTER.EMAIL_INVALID_FORMAT}</ErrorMessage>
            ) : (
              form.errors.email && <ErrorMessage>{MESSAGE_REGISTER.EMAIL_INVALID}</ErrorMessage>
            )
          ) : (
            <></>
          )}
          {!form.errors.email && !emailInValidJapan && TEXT_REGISTER.REQUIRED_EMAIL_TEXT}
        </p>
      </fieldset>

      <fieldset data-testid="password">
        <TitleInput text={TEXT_REGISTER.PASSWORD} required={true} />
        <Input
          id="password"
          type="password"
          name="password"
          value={form.values.password}
          onChange={form.handleChange}
          invalid={form.errors?.password}
        />
        <div className={`text-sm ${form.errors?.password ? 'text-danger-229' : 'text-secondary-354'}`}>
          {!form.values.password && form.errors.password ? (
            <ErrorMessage>{MESSAGE_COMMON.NOT_EMPTY}</ErrorMessage>
          ) : (
            <>
              {form.errors.password && (
                <ErrorMessage>
                  <div>
                    <p>{MESSAGE_REGISTER.PASSWORD_INVALID_TEXT}</p>
                    <p>{MESSAGE_REGISTER.PASSWORD_INVALID_REQUIRED_TEXT}</p>
                  </div>
                </ErrorMessage>
              )}
              {!form.errors.password && <p>{TEXT_REGISTER.PASSWORD_REQUIRED_TEXT}</p>}
              <ul className={`list-disc ${form.errors?.password ? 'ml-11' : 'ml-6'}`}>
                {(!form.errors.password || (form.errors.password && form.errors.password.includes(ENUM_PASSWORD_CREATE_ERROR.LENGTH))) && (
                  <li>{TEXT_COMMON.PASSWORD_REQUIRED_LENGTH}</li>
                )}
                {(!form.errors.password ||
                  (form.errors.password &&
                    _.intersection(form.errors.password || [], [
                      ENUM_PASSWORD_CREATE_ERROR.HAS_LOWERCASE,
                      ENUM_PASSWORD_CREATE_ERROR.HAS_UPPERCASE,
                      ENUM_PASSWORD_CREATE_ERROR.HAS_NUMBER,
                    ]).length > 0)) && <li>{TEXT_COMMON.PASSWORD_REQUIRED}</li>}
                {(!form.errors.password || (form.errors.password && form.errors.password.includes(ENUM_PASSWORD_CREATE_ERROR.HAS_FULL_WIDTH))) && (
                  <li>{TEXT_COMMON.PASSWORD_REQUIRED_CHARACTER}</li>
                )}
                {(!form.errors.password ||
                  (form.errors.password &&
                    _.intersection(form.errors.password || [], [
                      ENUM_PASSWORD_CREATE_ERROR.HAS_SYMBOLS,
                      ENUM_PASSWORD_CREATE_ERROR.HAS_SYMBOLS_REQUIRED,
                    ]).length > 0)) && <li>{TEXT_COMMON.PASSWORD_REQUIRED_SYMBOL}</li>}
              </ul>
            </>
          )}
        </div>
      </fieldset>

      <fieldset data-testid="password-confirm">
        <TitleInput text={TEXT_REGISTER.CONFIRM_PASSWORD} required={true} />
        <Input
          id="password-confirm"
          type="password"
          name="passwordConfirm"
          value={form.values.passwordConfirm}
          onChange={form.handleChange}
          invalid={form.errors?.passwordConfirm}
        />
        <p className={`text-sm ${form.errors.passwordConfirm ? 'text-danger-229' : 'text-secondary-354'}`}>
          {!form.values.passwordConfirm && form.errors.passwordConfirm && <ErrorMessage>{MESSAGE_COMMON.NOT_EMPTY}</ErrorMessage>}
          {form.values.passwordConfirm && form.errors.passwordConfirm && <ErrorMessage>{MESSAGE_REGISTER.PASSWORD_MATCHING}</ErrorMessage>}
        </p>
      </fieldset>

      <fieldset data-testid="local-government">
        <TitleInput text={TEXT_REGISTER.MUNICIPALITY} required={true} />
        <Input
          onSelect={(e) => {
            form.setFieldValue('municipality', e);
          }}
          value={form.values.municipality}
          onChange={(e) => {
            form.setFieldValue('municipality', e);
          }}
          name="municipality"
          classNameInput="!h-10"
          type="autocomplete"
          options={japanese_government}
          filterOption={(inputValue, option) =>
            option.value &&
            (option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 ||
              option.code.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1)
          }
          invalid={form.errors?.municipality}
        />
        <p className={`text-sm ${form.errors.municipality ? 'text-danger-229' : 'text-secondary-354'}`}>
          {form.values.municipality && form.errors.municipality && <ErrorMessage>{MESSAGE_REGISTER.GOVERNMENT_INCORRECT}</ErrorMessage>}
          {!form.values.municipality && form.errors?.municipality && <ErrorMessage>{MESSAGE_COMMON.NOT_EMPTY}</ErrorMessage>}
        </p>
        {!form.errors.municipality && <p className="text-sm text-secondary-354">{TEXT_REGISTER.MUNICIPALITY_REQUIRED}</p>}
      </fieldset>

      <fieldset data-testid="department">
        <TitleInput text={TEXT_REGISTER.DEPARTMENT} required={true} />
        <Input
          id="department"
          type="text"
          name="department"
          value={form.values.department}
          onChange={form.handleChange}
          invalid={form.errors?.department}
        />
        <p className={`text-sm ${form.errors.department ? 'text-danger-229' : 'text-secondary-354'}`}>
          {form.errors?.department ? (
            <ErrorMessage>{MESSAGE_COMMON.NOT_EMPTY}</ErrorMessage>
          ) : (
            <p className="text-sm text-secondary-354">{TEXT_REGISTER.DEPARTMENT_REQUIRED}</p>
          )}
        </p>
      </fieldset>

      <Button
        data-testid="btn-confirm"
        onClick={form.handleSubmit}
        className={`w-60 h-9.5 mt-8 mx-auto ${Object.keys(form?.errors)?.length > 0 && 'opacity-50 cursor-not-allowed'}`}
        color="primary"
        type="button"
        text={TEXT_REGISTER.GO_TO_CONFIRM}
      />
    </div>
  );
};

export default React.memo(EnterAccountInfomation);
